import PropTypes from "prop-types"
import {
    Backdrop,
    Box,
    Modal,
    Fade,
    Typography,
    IconButton,
    Button,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { useLocation, useNavigate } from "react-router-dom"

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 300, sm: 400 },
    bgcolor: "background.paper",
    borderRadius: "20px",
    boxShadow: "none",
    p: 4,
}

function MessageModal({ message, setMessage }) {
    const navigate = useNavigate()
    const location = useLocation()
    const open = !!message

    const handleClose = () => {
        setMessage(null)

        if (message?.navigateTo) {
            navigate(message.navigateTo, {
                state: message.replace !== false ? { from: location } : null,
                replace: message.replace !== false,
            })
        }
    }

    if (!message) return null

    const { type, text } = message

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{ backdrop: { timeout: 500 } }}
            sx={{ width: "100%", zIndex: 1500 }}
            role="dialog"
            aria-modal="true"
        >
            <Fade in={open}>
                <Box sx={style}>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault()
                            handleClose()
                        }}
                    >
                        <Box
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                            <IconButton
                                onClick={handleClose}
                                autoFocus
                                type="button"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Typography
                            id="transition-modal-title"
                            sx={{
                                fontSize: { xs: 25, sm: 35 },
                                color: "text.primary",
                            }}
                        >
                            {type}
                        </Typography>
                        <Typography
                            id="transition-modal-description"
                            sx={{ mt: 2, color: "text.primary" }}
                        >
                            {text}
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                mt: 3,
                                width: "100%",
                            }}
                        >
                            <Button
                                sx={{ width: "100%" }}
                                variant="outlined"
                                onClick={handleClose}
                                type="button"
                            >
                                CLOSE
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Fade>
        </Modal>
    )
}

MessageModal.propTypes = {
    message: PropTypes.shape({
        type: PropTypes.string,
        text: PropTypes.string,
        navigateTo: PropTypes.string,
        replace: PropTypes.bool,
    }),
    setMessage: PropTypes.func,
}

MessageModal.defaultProps = {
    message: null,
    setMessage: null,
}

export default MessageModal
